import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type { CoachingSession } from '@efdigital/ll-addon-data';
import { queryCoachingSessionsByCoach } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-sessions';
import type { CoachingCoachModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach';
import CoachService from '@efdigital/ll-xceed-v2/services/coach';
import { COACH_UPCOMING_KEYS } from '@efdigital/ll-xceed-v2/utils/coaching/session-current-categories';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

const UPCOMING_PAGE_SIZE = 20;

export type CoachingCoachSessionsIndexModel = CoachingCoachModel & {
  upcoming: CoachingSession[];
};

export default class CoachingCoachSessionsIndexRoute extends Route<CoachingCoachSessionsIndexModel> {
  @service declare coach: CoachService;
  @service declare store: Store;
  @service declare session: SessionService;

  async model(): Promise<CoachingCoachSessionsIndexModel> {
    const coachModel = this.modelFor('coaching.coach') as CoachingCoachModel;
    const coachUserId = this.session.cached.userId!;

    const upcoming = await this.store.request(
      queryCoachingSessionsByCoach(coachUserId, COACH_UPCOMING_KEYS, {
        offset: 0,
        limit: UPCOMING_PAGE_SIZE,
      })
    );

    return {
      ...coachModel,
      upcoming: upcoming.content.data,
    };
  }
}
